<ion-grid class="no_padding" >        
    <ion-row class="ion-align-items-center ion-justify-content-between"> 
        <ion-col size="12" size-md="6" class="title_card">
            {{ 'PLANNING_SUMMARY' | translate }}
            <small>&nbsp;{{this.translateService.instant('PLANNING_SUMMARY_PERIOD').replace('#start_date#', this.startDatePlanningSummary).replace('#end_date#', this.endDatePlanningSummary)}}</small>   
        </ion-col>     
        <ion-col id="col_select_operation" size="12" size-md="6">
            <form [formGroup]="this.operationForm"> 
                <app-operation-select 
                    #operationSelect
                    label="{{ 'OPERATIONS' | translate }}" 
                    formName="operationKey" 
                    [withSpeechToText]="true" 
                    [displayItemsSelected]="true" 
                    [multiple]="false" 
                    (onChangeItems)="this.onChangeOperations($event)"
                    />    
            </form>
        </ion-col>
    </ion-row>     
</ion-grid>

@if(this.isFetching){
    <div class="bloc_loading">
        <ion-spinner></ion-spinner>
    </div>        
}
@else {
    @if(this.planningSummary){
    
    <div id="planning_summary">
        <div id="planning_summary_header">
            <div class="planning_summary_first_col"></div>
            @for(retailer of this.planningSummary.retailers; track $index){
                <div class="planning_summary_retailer">
                    <div class="planning_summary_retailer_name">{{retailer.name}}</div>
                    <div class="planning_summary_retailer_logo">
                        <app-retailer-logo [retailer]="retailer.retailerLogo" [withMarginRight]="false" size="small"/>  
                    </div>
                </div>
            }
        </div>
        <div id="planning_summary_content">
            <div class="planning_summary_content_row planning_summary_total">
                <div class="planning_summary_first_col"><div>{{ 'TOTAL' | translate }}</div></div>
                @for(retailer of this.planningSummary.retailers; track $index){                
                    <div class="planning_summary_nb_missions">
                        <div>
                            {{this.planningSummary.nbMissions.get(retailer.code)?.all || '-'}}
                            @if(this.planningSummary.nbMissions.get(retailer.code)?.all){
                                <small>&nbsp;&nbsp;({{this.planningSummary.nbMissions.get(retailer.code)?.done || '0'}})</small>
                            }
                        </div>                            
                    </div>
                }
            </div>
            @for(area of this.planningSummary.areas; track $index){
                <div class="planning_summary_content_row planning_summary_area">
                    <div class="planning_summary_first_col"><div><ion-icon name="map-outline"></ion-icon>{{area.name}}</div></div>
                    @for(retailer of this.planningSummary.retailers; track $index){                
                        <div class="planning_summary_nb_missions">
                            <div>
                                {{area.nbMissions.get(retailer.code)?.all || '-'}}
                                @if(area.nbMissions.get(retailer.code)?.all){
                                    <small>&nbsp;&nbsp;({{area.nbMissions.get(retailer.code)?.done || '0'}})</small>
                                }
                            </div>                                
                        </div>
                    }
                </div>
                @for(sector of area.sectors; track $index){
                    <div class="planning_summary_content_row planning_summary_sector">
                        <div class="planning_summary_first_col"><div><ion-icon name="trail-sign-outline"></ion-icon>{{sector.name}}</div></div>
                        @for(retailer of this.planningSummary.retailers; track $index){                
                            <div class="planning_summary_nb_missions">
                                <div>
                                    {{sector.nbMissions.get(retailer.code)?.all || '-'}}
                                    @if(sector.nbMissions.get(retailer.code)?.all){
                                        <small>&nbsp;&nbsp;({{sector.nbMissions.get(retailer.code)?.done || '0'}})</small>
                                    }
                                </div>                                    
                            </div>
                        }
                    </div>

                }
            }
        </div>
    </div>
    
    }
    @else{
        <marv-message type="info">{{this.translateService.instant('MSG_NO_PLANNING_SUMMARY').replace('#start_date#', this.startDatePlanningSummary).replace('#end_date#', this.endDatePlanningSummary)}}</marv-message>
    }
}